import React, { useEffect, useState } from "react";

import api, { handleApi } from "pages/api/api";
import { useAlert } from "pages/context/AlertContext";
import { useAuth } from "pages/context/AuthContext";
import PageHeader from "pages/components/PageHeader";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

import Card from "@mui/material/Card";
import CircularProgress from "@mui/material/CircularProgress";

export default function Telegram() {
  const { showAlert } = useAlert();
  const { userData } = useAuth();

  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState(null);
  const [telegramLigado, setTelegramLigado] = useState(false);

  const carregarPreferencias = async () => {
    if (!userData?.id) return;

    setLoading(true);

    const [data, err] = await handleApi(
      api.post("Chats/SelPreferenciasNotificacoesChats", {
        idutilizador: userData.id,
      })
    );

    if (err) {
      showAlert(err, "error");
      setLoading(false);
      return;
    }

    setTelegramLigado(data?.telegram_ligado === true || Number(data?.telegram_ativo || 0) === 1);

    setLoading(false);
  };

  useEffect(() => {
    carregarPreferencias();
  }, [userData?.id]);

  const gerarCodigo = async () => {
    if (!userData?.id) {
      showAlert("Utilizador não identificado.", "error");
      return;
    }

    setLoading(true);

    const [data, err, meta] = await handleApi(
      api.post("Chats/GerarCodigoLigacaoTelegram", {
        idutilizador: userData.id,
      })
    );

    if (err) {
      showAlert(err, "error");
      setLoading(false);
      return;
    }

    setDados(data);

    if (meta?.message) {
      showAlert(meta.message, meta.severity || "success");
    }

    setLoading(false);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      {loading && (
        <MDBox py={2} display="flex" alignItems="center" justifyContent="center">
          <CircularProgress />
        </MDBox>
      )}

      <PageHeader />

      <MDBox py={3}>
        <Card>
          <MDBox p={3}>
            <MDTypography variant="h6" fontWeight="medium">
              Ligar Telegram
            </MDTypography>

            <MDTypography variant="body2" color="text" mt={1}>
              Para receber notificações no Telegram, gere um código através do botão abaixo.
            </MDTypography>

            {!telegramLigado ? (
              <MDBox mt={3}>
                <MDButton color="info" onClick={gerarCodigo} disabled={loading}>
                  Gerar código de ligação
                </MDButton>
              </MDBox>
            ) : null}

            {dados && (
              <MDBox mt={3}>
                <MDTypography variant="button" fontWeight="bold">
                  Bot:
                </MDTypography>
                <MDTypography variant="body2" mb={2}>
                  @{dados.bot}
                </MDTypography>

                <MDTypography variant="button" fontWeight="bold">
                  Comando:
                </MDTypography>
                <MDBox
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  mb={2}
                  sx={{
                    p: 1.5,
                    borderRadius: 1,
                    backgroundColor: "#f5f5f5",
                  }}
                >
                  <MDTypography
                    variant="body2"
                    sx={{
                      fontFamily: "monospace",
                      wordBreak: "break-word",
                    }}
                  >
                    {dados.comando}
                  </MDTypography>

                  <MDButton
                    size="small"
                    color="dark"
                    onClick={() => {
                      navigator.clipboard.writeText(dados.comando);
                      showAlert("Comando copiado para clipboard.", "success");
                    }}
                    sx={{ ml: 2 }}
                  >
                    Copiar
                  </MDButton>
                </MDBox>

                <MDTypography variant="body2" color="text">
                  Este código expira em {dados.expira_minutos || 15} minutos.
                </MDTypography>
              </MDBox>
            )}

            <MDTypography variant="body2" color="text" mt={1}>
              Depois de gerar o código, abra o Telegram, na pesquisa escreva{" "}
              <strong>"jfb_notificacoes_bot"</strong>
              e abra o bot apresentado.
              <br />
              De seguida, já nesse bot <strong>"JFB Notificações"</strong>, envie-lhe a mensagem com
              o comando gerado pelo botão. Algo como "/start JFB-nnnnnn" (sem aspas, e substituindo
              o nnnnnn pelo código gerado).{" "}
              <strong>Pode simplesmente copiar e colar o comando gerado.</strong>
              <br />
              Irá receber uma resposta do tipo "Conta ligada com sucesso à JFB" (JFB = JF Bebidas).
            </MDTypography>

            <MDBox mt={2}>
              <MDButton color="success" onClick={carregarPreferencias} disabled={loading}>
                Verificar ligação
              </MDButton>
            </MDBox>

            {telegramLigado ? (
              <MDBox mt={3}>
                <MDTypography variant="body2" color="success" fontWeight="medium">
                  A sua conta já está ligada ao Telegram.
                </MDTypography>
              </MDBox>
            ) : null}
          </MDBox>
        </Card>
      </MDBox>
    </DashboardLayout>
  );
}
